import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";

import { apiRequest } from "../api/apiClient.js";

/**
 * Meldet das Gerät für Push-Benachrichtigungen an.
 *
 * Nur in der App: im Browser gibt es über dieses Plugin keinen FCM-Token. Schlägt
 * irgendetwas fehl, bleibt es dabei — ohne Push funktioniert die Anwendung weiter, nur
 * eben nur mit offener App. Deshalb wirft diese Funktion nicht.
 */
export async function registerPush(): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  try {
    let permission = await PushNotifications.checkPermissions();
    if (permission.receive === "prompt") {
      permission = await PushNotifications.requestPermissions();
    }
    if (permission.receive !== "granted") {
      return;
    }

    await PushNotifications.addListener("registration", (token) => {
      void apiRequest("/push/devices", {
        method: "POST",
        body: { token: token.value, platform: "ANDROID" },
      }).catch(() => {
        // Der Token kommt beim nächsten Start wieder; ein verlorener Versuch ist kein
        // Grund, dem Benutzer etwas zu melden.
      });
    });

    await PushNotifications.addListener("registrationError", () => {
      // Kein google-services.json im Build, oder keine Netzverbindung.
    });

    await PushNotifications.register();
  } catch {
    // Plugin nicht verfügbar — etwa in einem Web-Build der App-Oberfläche.
  }
}
